/**
 * Strip Extra Whitespace
 * @param {String} string
 */
export function trimWhitespace (string) {
  if (!string) return ''
  return string.replace(/^ +| +$/gm, ' ').trim()
}
